// AYA PRO Phase 1 — Page de choix d'espace au premier lancement (masque rotatif + 2 gros boutons).
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setSpace, setProProfile } from "@/pro/proSpace";
import "./SpaceChoice.css";

const PROFILES = [
  { id: "commercant", icon: "🛍️", label: "Commerçant", sub: "Boutiques, étals, salons" },
  { id: "business", icon: "💼", label: "Business", sub: "PME & services" },
  { id: "entreprise", icon: "🏢", label: "Entreprise", sub: "Grands comptes" },
  { id: "municipalite", icon: "🏛️", label: "Municipalité", sub: "Les 13 mairies d'Abidjan" },
];

export default function SpaceChoicePage() {
  const navigate = useNavigate();
  const [step, setStep] = useState("space");

  const chooseNormal = () => {
    setSpace("normal");
    navigate("/", { replace: true });
  };
  const chooseProfile = (id) => {
    setSpace("pro");
    setProProfile(id);
    navigate("/pro", { replace: true });
  };

  return (
    <div className="space-choice" data-testid="space-choice-page">
      <div className="space-choice-mask-wrap">
        <div className="space-choice-aura" />
        <img src="/aya/splash.png" alt="AYA AI" className="space-choice-mask" />
      </div>
      <h1 className="space-choice-title">AYA AI</h1>

      {step === "space" ? (
        <>
          <p className="space-choice-sub">Choisissez votre espace</p>
          <div className="space-choice-buttons">
            <button
              className="space-big-btn space-btn-pro"
              data-testid="space-choice-pro-btn"
              onClick={() => setStep("profile")}
            >
              <span className="sb-icon">💼</span>
              Professionnels
              <span className="sb-sub">Commerçants · Business · Entreprises</span>
            </button>
            <button
              className="space-big-btn space-btn-normal"
              data-testid="space-choice-normal-btn"
              onClick={chooseNormal}
            >
              <span className="sb-icon">🌿</span>
              AYA
              <span className="sb-sub">L'intelligence locale, notre identité</span>
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="space-choice-sub">Quel est votre profil professionnel ?</p>
          <div className="space-profiles">
            {PROFILES.map((p) => (
              <button
                key={p.id}
                className="space-profile-card"
                data-testid={`space-profile-${p.id}`}
                onClick={() => chooseProfile(p.id)}
              >
                <span className="sp-icon">{p.icon}</span>
                {p.label}
                <span className="sp-sub">{p.sub}</span>
              </button>
            ))}
          </div>
          <button className="space-choice-back" data-testid="space-choice-back-btn" onClick={() => setStep("space")}>
            ← Retour
          </button>
        </>
      )}
      <p className="space-choice-footer">Vous pourrez changer d'espace à tout moment.</p>
    </div>
  );
}
